<template>
   <div class="Invites ">
    <div class="invites">
       <!-- <div>
          TEst
      </div> -->
        <form @submit.prevent="send_invite" required class="text-center send_invite" >
            <div class="fitcontents" >
                <input class="name" v-on:keyup="clearError" type="text" id="name" name="name" v-model="name"  placeholder="Enter Name"> 
            </div>

            <div class="fitcontents" >
                <input class="cell_number" v-on:keyup="clearError" type="number" id="cell_number"   name="cell_number"  v-model="cell_number" placeholder="Enter Cell Number e.g. 0781234567"> 
            </div>
            <div class="fitcontents" >
                <input class="email_address"  v-on:keyup="clearError" type="text" id="email_address"  name="email_address" v-model="email_address"  placeholder="Enter Email Address"> 
            </div>
            <div class="fitcontents" >
                <button class="btn_invite">Send Invitation</button>
            </div>
        </form>
        <div class="text_danger" >
            <p  v-if="errorText"  class="text-danger">{{errorText}}</p>
        </div>
    </div>
    <div style="clear: left;">
        <ul class="list-group pull-down" id="contact_list">
            <li class="list-group-item"  v-for="(value,propertyName) in render_sent_invite" :key=propertyName > 
                <Invite  :p_sent_invite="value" />
            </li>
        </ul>
    </div>

    <Invite/>
    <!-- <button @click="Check1">
        check12
    </button> -->
    <!-- {{render_sent_invite}} -->
   <!-- <button @click="render_sent_invite()">asdf</button> -->
   </div>
</template>

<script>
    import axios from 'axios';
    // import exportFile from './ajaxfile.php'
    import Invite from "./Invite.vue";
    import { v4 as uuidv4 } from 'uuid';

    export default {
        name: 'Invites',
        components: {
            Invite
        }, 
        props: {
            wss: Object,
        },
        data: function () {
            return {
                name: '',
                cell_number: '',
                email_address: '', 
                errorText : '', 
                sent_invites: [],
                sms: {}, 
                url : 'talk.expertron.co.za', 
                message: 'You have been invited to use ',
                uuid: '',
                sender : this.wss.id
            }
        },
        mounted: function() {
            var qaller = {} ;
            var sms_queue = {} ; 

            this.wss.send({cmd:'db', data: {act: "fetchsent_invites", data: {msisdn: '', message:'',name:'', email:'',uuid:''}}}); 
            this.wss.send({cmd:'db', data: {act: "fetchsms", data: {msisdn: '', message:'',name:'', email:'',uuid:''}}}); 

            this.wss.onaccept = (call, data) => {   
               
               if(call == 'db' && data.cmd =="db_fetchsent_invites") {
                  qaller = data.data;
                  qaller = JSON.parse(qaller)
                  // this.wss.send({cmd:'db', data: {act: "fetchsent_invites", data: {msisdn: '', message:'',name:'', email:''}}}); 
               }

               if(call == 'db' && data.cmd =="db_fetchsms") {
                  sms_queue = data.data;
                  sms_queue = JSON.parse(sms_queue)
                  // console.log(sms_queue);
                  // console.log(sms_queue);
                  // this.wss.send({cmd:'db', data: {act: "fetchsent_invites", data: {msisdn: '', message:'',name:'', email:''}}}); 
               }
               // console.log(Object.keys(sms_queue).length);
               if (Object.keys(qaller).length && Object.keys(sms_queue).length) {
                  var obj ;  
                  var sent = [];
                  this.sms_queue = [] ; 

                  qaller.findIndex( qallers => {
                     sms_queue.findIndex(sms_queues => {
                        if(qallers.id == sms_queues.id ) {
                           obj = {
                              id : sms_queues.id,
                              name : qallers.name,
                              status : sms_queues.status,
                              delivered_date: sms_queues.delivered_date
                           }
                           sent.push(obj);
                        }
                     })
                  });
                  this.sent_invites = [];
                  this.sent_invites = [...this.sent_invites, ...sent];
               }
            };

        },
        methods: {
            send_invite() {
                // this.wss.send({cmd:'db', data: {act: "fetchsent_invites", data: 'Ptest' } }); 
               // this.validate_fields();
               if(this.validate_fields()) {
                  this.uuid = uuidv4();
                  var invite_message = this.message + this.url+'?'+'uuid='+this.uuid ;
                  //console.log('cell number: '+this.cell_number+' invite_message: '+invite_message+' name: '+this.name+' email_address: '+this.email_address+' uuid: '+ this.uuid);
                  this.wss.send({cmd:'db', data: {act: "setsms", data:{ msisdn: this.cell_number, message: invite_message,name: this.name, email:this.email_address, uuid:this.uuid, sender:this.sender}}});
                  this.wss.send({cmd:'db', data: {act: "fetchsent_invites", data: {msisdn: '', message:'',name:'', email:'',uuid:'',sender:''}}}); 
                  this.clearField();
                  
              }
            },
            validate_fields() {
               // check if input is provided 
              if(!this.cell_number) {
                this.errorText = "Please enter a Cell number"
                return false ;
              }else if(!this.name){
                this.errorText = "Please enter a Name"
                return false ;
              }else if(!this.email_address) {
                this.errorText = "Please enter an Eamil address"
                return false ; 
              }
               
              if(!this.cell_number.match("[0-9]+")) {
                this.errorText = "Cellphone number contains special characters"
                return false ;
              }
              
              console.log(this.cell_number.length == 11 && this.cell_number[0] == '2' && this.cell_number[1] == '7');

              console.log(this.cell_number.length != 11);
              console.log(this.cell_number[0] != '2') ;
              console.log(this.cell_number[1] != '7') ;

              if(this.cell_number.length != 10) {
                if(!(this.cell_number.length == 11 && this.cell_number[0] == '2' && this.cell_number[1] == '7')) {
                  this.errorText = "Invalid Cellphone number"   
                  return false ;
                }
              }

              if(!this.validateEmail(this.email_address)) {
                this.errorText = "Invalid email addreass"
                return false
              }

              if(this.cell_number[0] == '0') {
                var cell = this.cell_number.substr(1,9); 
                this.cell_number  = '27'+cell; 
              }


               //remove any special charactors 
              this.name = this.remove_special_characters(this.name);
              return true ;
            },
            clearError() {
                this.errorText = "";
            },
            renderSentInvite() {
               return this.sent_invites
            },
            Check1(){
              console.log(this.wss.id);
            },
            remove_special_characters(string) {
              return string.replace(/[^\w\s]/gi, '') ;
            },
            validateEmail (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(String(email).toLowerCase());
            },
            clearField() {
              this.name = "";
              this.cell_number = "";
              this.email_address = "";
            }

        },
        computed: {
          render_sent_invite : function() {
            //  alert('check');
             return  this.sent_invites
          }
        } 
    }
</script>


<style scoped>
    .fitcontents {
      display:contents;
    }
    .name, .cell_number , .email_address  {
      margin-top: 10px;
      margin-bottom : 10px;
      text-align: center;
    }
    .name {
      width : 23.3%;
      margin-left: 1.5%;
    }

    .cell_number , .email_address  {
      width : 24.8%;
    }
    .text_danger {
      margin-left: 20px;
    }

    .list-group-item {
      position: relative;
      display: block;
      padding: 0rem 1.25rem;
      margin-bottom: -1px;
      background-color: #fff;
      border: 0px solid rgba(0,0,0,.125);
    }
    .invites {
      float:left;
      display: contents;
    }
    .send_invite{
      display: flex;
    }
    .btn_invite{
      width: 23.3%;
      height: 31px;
      margin: 12px;
    }

</style>
